import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import DropZoneAzure from './DropZoneAzure.js';
import ListingCard from './ListingCard.js';
//import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons';
import useApiFetch from '../ApiFetch.js';

import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import { validate } from 'uuid';
import moment from 'moment';


/*
 - Add reference to form
 - From refefence, call form submit
 */

export const AddListing = forwardRef((props, ref) => {

    const { listItem, updatedListing } = props;

    const apiFetch = useApiFetch();

    const refAddListingForm = useRef(null);

    const validate = () => {

        let returnValue = true;

        if (listItem.listingName.length <= 3)
            returnValue = false;


        return returnValue;
    }

    useImperativeHandle(ref, () => ({

        submitListing() {

            //console.log("Submit");

            if (refAddListingForm.current) {

                //const formData = new FormData(refAddListingForm.current);

                console.log("About to submit");

                addNewListing();

                //refAddListingForm.current.submit(formData);
            }

        }

    })
    )


    const [newListItem, setNewListItem] = useState({ listingName: '', listingDate: undefined, listingAddress: '', listingCity: '', listingStateProv: '', ListingPostalCd: '', listingCircuit: '', listingClass: '', listingImageURL: '', listingPresignedURL: '', isPreview: true, listingProfileId: null, listingRegisterURL: '', listingDetailURL: '' });
    const [imgPreviewUrl, setImgPreviewUrl] = useState(null);

    const authUser = useAuthUser();

    useEffect(() => {
        if (listItem)
            setNewListItem(listItem);
    }, []);


    const addNewListing = async (event) => {

        if (event) {
            event.preventDefault();
        }

        // console.log("Submitted");

        // console.log(listItem);

        //console.log('Tournament Name:', listItem.listingName);

        //await fetch('/api/listing/Create?listingId=' + encodeURIComponent(listItem.ListingId) , requestOptions)
        // await request.post('/api/listing/create', {method: 'POST', body: listItem, headers: {
        //  'Content-Type': 'multipart/form-data',
        //  'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
        //},})//requestOptions)
        //    //.then((resp) => {
        //       //getData();
        //    //})


        await apiFetch.post('/api/listing/create', newListItem)
            .then(
                resp => {
                    if (resp.data && updatedListing) {
                        updatedListing(resp.data?.value);
                    }
                    if (props.close) {
                        props.closeModal();
                    }
                    //(resp.data);
                }
            )
            .finally()
            .catch((ex) => {
                console.error(ex);
            });
        //   

    };

    const fileUploaded = (fileName) => {
        if (fileName) {
            setImgPreviewUrl(fileName);
            if (listItem) {
                listItem.listingImageURL = fileName;
            }
            setNewListItem({ ...listItem, listingImageURL: fileName });
        }
    };

    return (

        <div className="row">
            <div className="col-lg-6 col-12">
                <form name="formListing" ref={refAddListingForm} onSubmit={addNewListing}>


                    <h6>Tournament Logo</h6>
                    <DropZoneAzure fileUploaded={fileUploaded} />

                    <div className="row">
                        <div className="col-12">

                            <div className="form-floating mt-1 mb-1">
                                <input
                                    type="text"
                                    id="listingName"
                                    value={newListItem.listingName}
                                    name="listingName"
                                    required
                                    className={`form-control ${newListItem.listingName?.length >= 3 ? 'is-valid' : 'is-invalid'}`}
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                />
                                <label htmlFor="listingName">Tournament Name:</label>
                                <div className="invalid-feedback">
                                    Enter a tournament name longer then 3 characters.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <div className="form-floating mt-1 mb-1">

                                <input
                                    type="date"
                                    id="listingDate"
                                    value={newListItem.listingDate ?? ''}
                                    required
                                    className={`form-control ${newListItem.listingDate && moment(newListItem.listingDate).isValid() ? 'is-valid' : 'is-invalid'}`}
                                    name="listingDate"
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                />
                                <label htmlFor="listingDate">Start Date:</label>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-6">


                            <div className="form-floating mt-1 mb-1">
                                <select className="form-select" id="listingCircuit"
                                    name="listingCircuit"
                                    value={newListItem.listingCircuit ? newListItem.listingCircuit : "OTHER"}
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                >

                                    <option value="ATA">ATA</option>
                                    <option value="GTMA">GTMA</option>
                                    {/*<option value="ISKL">ISKL</option>*/}
                                    <option value="NASKA">NASKA</option>
                                    <option value="OPEN">OPEN</option>
                                    <option defaultValue="OTHER">OTHER</option>
                                    <option value="TKO">TKO</option>
                                    <option value="UFAF">UFAF</option>

                                </select>
                                <label htmlFor="listingCircuit">Circuit:</label>

                                {/*<input
              type="hidden"
              id="listingCircuit"
              name="listingCircuit"
              className="form-control"
              value={selectedCircuit.value}
              onChange={(e) => setNewListItem({...newListItem, [e.target.name]: e.target.value})}
              />
              */}

                            </div>
                        </div>

                        <div className="col-6">

                            <div className="form-floating mt-1 mb-1">
                                <input
                                    type="text"
                                    id="listingClass"
                                    name="listingClass"
                                    className="form-control"
                                    value={newListItem.listingClass}
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                />

                                <label htmlFor="listingClass">Class / Region:</label>

                            </div>
                        </div>
                    </div>

                    {/* <div className="row">
        <div className="col-12">

          <div className="form-floating mt-1 mb-1">
              <input
              type="text"
              id="listingAddress"
              name="listingAddress"
              className="form-control"
              value={newListItem.listingAddress}
              onChange={(e) => setNewListItem({...newListItem, [e.target.name]: e.target.value})}
              />
            
              <label htmlFor="listingAddress">Address:</label>

          </div>
        </div>
      </div>
      */}

                    <div className="row">
                        <div className="col-8">
                            <div className="form-floating mt-1 mb-1">
                                <input
                                    type="text"
                                    id="listingCity"
                                    name="listingCity"
                                    className={`form-control ${newListItem.listingCity?.length >= 3 ? 'is-valid' : 'is-invalid'}`}
                                    value={newListItem.listingCity}
                                    required
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                />

                                <label htmlFor="listingCity">City:</label>

                            </div>
                        </ div>
                        <div className="col-4">
                            <div className="form-floating mt-1 mb-1">
                                <input
                                    type="text"
                                    id="listingStateProv"
                                    name="listingStateProv"
                                    className={`form-control ${newListItem.listingStateProv?.length == 2 ? 'is-valid' : 'is-invalid'}`}
                                    maxLength="2"
                                    minLength="2"
                                    required
                                    value={newListItem.listingStateProv}
                                    pattern="[a-zA-Z][a-zA-Z]"
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                />

                                <label htmlFor="listingStateProv">State</label>

                            </div>

                        </div>
                    </div>

                    {/* <div className="row">
        <div className="col-5">

          <div className="form-floating mt-1 mb-1">
              <input
              type="text"
              id="listingPostalCd"
              name="listingPostalCd"
              className="form-control"
              value={newListItem.listingPostalCd}
              onChange={(e) => setNewListItem({...newListItem, [e.target.name]: e.target.value})}
              />
            
              <label htmlFor="listingPostalCd">Postal Code:</label>

          </div>
        </div>
      </div>
      */}






                    <div className="row">
                        <div className="col-12">
                            <div className="form-floating mt-1 mb-1">
                                <input
                                    type="text"
                                    id="ListingRegisterURL"
                                    name="ListingRegisterURL"
                                    className="form-control"
                                    value={newListItem.ListingRegisterURL}
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                />

                                <label htmlFor="ListingRegisterURL">Registration URL</label>
                                <div>
                                    <h6 className="ps-1 text-secondary fw-light" style={{ fontSize: ".70em" }}>Enables Register button</h6>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="form-floating mt-1 mb-1">
                                <input
                                    type="text"
                                    id="ListingDetailURL"
                                    name="ListingDetailURL"
                                    className="form-control"
                                    value={newListItem.ListingDetailURL}
                                    onChange={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                                />

                                <label htmlFor="ListingDetailURL">Information URL</label>
                                <div>
                                    <h6 className="ps-1 text-secondary fw-light" style={{ fontSize: ".70em" }}>Enables Details button</h6>
                                </div>

                            </div>
                        </div>
                        <div className='col-3 gx-0'>

                        </div>
                    </div>

                    <input
                        type="hidden"
                        id="listingProfileId"
                        value={authUser?.profile.profileId}
                        name="listingProfileId"
                        onSubmit={(e) => setNewListItem({ ...newListItem, [e.target.name]: e.target.value })}
                    />
                    {/*<span>
          <button type="submit" className='btn btn-primary'>Submit</button>
          </span>
          */}
                </form>
            </div>
            <div className='col-lg-6 col-12'>
                <h6 className='mb-3'>Preview</h6>

                <ListingCard listItem={[newListItem]} imgPreviewUrl={imgPreviewUrl}>

                </ListingCard>
            </div>

        </div>
    );
});

export default AddListing;

//{ listingName={listItem.listingName ? listItem.listingName : ''}
//listingDate={listItem.listingDate ? listItem.listingDate : ''
